import List from '../../src/legacy/List.tsx';
export default List;
